// Refactored: This file now re-exports from the integrations folder
// The original 2000+ line file has been split into:
// - integrations/EmailIntegration.js
// - integrations/FacebookIntegration.js
// - integrations/GoogleSheetsIntegration.js
// - integrations/index.js (main component)

import Integrations from "./integrations/index";
export default Integrations;
